import React from 'react';
import { steps } from './constants';

const HowItWorks = () => {
  return (
    <div className='bfm-how-it-works'>
      <p className='bfm-section-header'>HOW IT WORKS</p>
      <div className='bfm-steps-wrapper'>
        {
          steps.map(({img, text}) => (<div className='bfm-step-item'>
            <div className='bfm-step-item-image'>
              <img  src={img} alt='step' />
            </div>
            <p className='bfm-step-item-text'>{text}</p>
          </div>))
        }
      </div>
      <div className='bfm-note-wrapper'>
        <div className='bfm-note'>
          <p style={{ fontWeight: 600 }}>Notes:</p>
          <ul style={{ fontSize: '16px' }}>
            <li>Your item will be added to your ShippingCart account.</li>
            <li>Buy-For-Me service fee will be based on your total item cost including local shipping fee (LSF) per checkout per store.</li>
            <li style={{listStyle: 'none'}}>
              <table className="table item-list">
                <thead>
                  <tr>
                    <th>Item + LSF Cost</th>
                    <th>
                      Buy-For-Me Fee
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Less than 300USD</td>
                    <td>Fixed 15USD</td>
                  </tr>
                  <tr>
                    <td>300USD and more</td>
                    <td>5% of total cost</td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li style={{ listStyle: 'none' }}><i style={{ color: '#707070', fontSize: '14px' }}>*A 5% transactional fee will be added.</i></li>
            <li style={{ listStyle: 'none' }}><i style={{ color: '#707070', fontSize: '14px' }}>*Local shipping refers to the delivery of item to our warehouse abroad. Some online stores waive  local shipping fees.</i></li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default HowItWorks;


/** WEBPACK FOOTER **
 ** ./src/components/BuyForMe/HowItWorks.js
 **/